(function () {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      // DROPDOWMS
      const Elements = document.getElementsByClassName('search-list');
      const body = document.getElementById('body');
      const MenuItems = Array.from(Elements);
      // window.matchMedia("(max-width: 749px)").matches
      const disableScroll = (e) => {
        e.preventDefault();
      };
      function timeout1() {
        document.getElementById('search-ddowns').classList.remove('is-open');
        document.getElementById('search-ddowns').classList.remove('ani');
        document.getElementById('dropdown-food').classList.remove('is-open');
        document.getElementById('dropdown-sweets').classList.remove('is-open');
        document.getElementById('dropdown-drink').classList.remove('is-open');
        document.getElementById('dropdown-alcohol').classList.remove('is-open');
        document.getElementById('dropdown-beauty').classList.remove('is-open');
        document.removeEventListener('touchmove', disableScroll, { passive: false });
        document.removeEventListener('mousewheel', disableScroll, { passive: false });
      }

      function timeout2() {
        document.getElementById('search-ddowns').classList.add('ani');
      }
      if (document.querySelectorAll('.js-link-dropdown').length > 0) {
        const triggers = document.querySelectorAll('.js-link-dropdown');
        const dropdowns = document.querySelectorAll('.search-ddowns__ddown');
        const closeBtns = document.querySelectorAll('.search-ddowns__ddown__header__close');
        const dropdownsWrap = document.getElementById('search-ddowns');

        const dropdownToggler = (targetTrigger, targetDropdown) => {
          const dropdownWrap = document.getElementsByClassName('search-ddowns')[0];
          var openedDropdowns = 0;
          let winW = window.innerWidth;

          triggers.forEach((trigger) => {
            if (targetTrigger === trigger) {
              trigger.classList.toggle('is-open');
            } else {
              trigger.classList.remove('is-open');
            }
          });
          dropdowns.forEach((dropdown) => {
            if (targetDropdown === dropdown) {
              dropdown.classList.toggle('is-open');
              if (dropdown.classList.contains('is-open')) {
                openedDropdowns++;
                if (winW >= 750) {
                  dropdown.style.maxHeight = dropdown.scrollHeight + 'px';
                }
              } else {
                if (winW >= 750) {
                  dropdown.style.maxHeight = 0;
                }
              }
            } else {
              dropdown.classList.remove('is-open');
              if (winW >= 750) {
                dropdown.style.maxHeight = 0;
              }
            }
          });
          //check if there is any dropdown open, is so, add class is-open to dropdownWrap
          if (openedDropdowns > 0) {
            dropdownWrap.classList.add('is-open');
            if (winW < 750) {
              body.style.overflowY = 'hidden';
              document.addEventListener('touchmove', disableScroll, { passive: false });
              document.addEventListener('mousewheel', disableScroll, { passive: false });
            }
          } else {
            dropdownWrap.classList.remove('is-open');
            body.style.overflowY = 'auto';
            document.removeEventListener('touchmove', disableScroll, { passive: false });
            document.removeEventListener('mousewheel', disableScroll, { passive: false });
          }
        };
        const closeDropdownBtn = (btn) => {
          const dropdownWrap = document.getElementsByClassName('search-ddowns')[0];
          triggers.forEach((trigger) => trigger.classList.remove('is-open'));
        };

        //APPLY
        triggers.forEach((trigger) => {
          trigger.addEventListener(
            'click',
            function (e) {
              const targetDropdown = document.getElementById(this.hash.slice(1));
              e.preventDefault();

              dropdownToggler(trigger, targetDropdown);
            },
            false,
          );
        });
        dropdowns.forEach((btn) => {
          btn.addEventListener('click', function () {
            closeDropdownBtn(this);
            body.style.overflowY = 'auto';
            document.removeEventListener('touchmove', disableScroll, { passive: false });
            document.removeEventListener('mousewheel', disableScroll, { passive: false });
          });
          btn.addEventListener('click', () => {
            timeout1();
            timeout2();
          });
        });
        closeBtns.forEach((btn) => {
          btn.addEventListener('click', function () {
            closeDropdownBtn(this);
            body.style.overflowY = 'auto';
            document.removeEventListener('touchmove', disableScroll, { passive: false });
            document.removeEventListener('mousewheel', disableScroll, { passive: false });
          });
          btn.addEventListener('click', () => {
            timeout1();
            timeout2();
          });
        });
        document.addEventListener('click', function (e) {
          const dropdownParent = $(e.target).parents('.js-link-dropdown').length;
          const dropdownParentDdowns = $(e.target).parents('.search-ddowns').length;

          if (
            e.target.classList.contains('js-link-dropdown') === false &&
            dropdownParent === 0 &&
            e.target.classList.contains('search-ddowns') === false &&
            dropdownParentDdowns === 0
          ) {
            let winW = window.innerWidth;
            triggers.forEach((trigger) => {
              trigger.classList.remove('is-open');
            });
            dropdowns.forEach((dropdown) => {
              if (winW >= 750) {
                dropdown.classList.remove('is-open');
                dropdown.style.maxHeight = 0;
              }
            });
          }
        });
      }
    },
    false,
  );
})();
